// Modeled after https://mui.com/system/the-sx-prop/#main-content
// We want to allow developers to customize the margin and padding, but no other styles.
// V5 of Material UI won't need this; they provide the ability to custom inject styles as a prop.

import { createTheme } from '@material-ui/core/styles';

// By default, spacing is 8px in theme.
const theme = createTheme();

// We will support all shorthands listed at https://mui.com/system/the-sx-prop/ with v5.
const spacingAllowList = [
  'margin',
  'marginTop',
  'marginRight',
  'marginBottom',
  'marginLeft',
  'padding',
  'paddingTop',
  'paddingRight',
  'paddingBottom',
  'paddingLeft',
];

const toKebabCase = (str) => {
  return str
    .split('')
    .map((letter, idx) => {
      return letter.toUpperCase() === letter
        ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
        : letter;
    })
    .join('');
};

const filterValidProps = (sxProps) => {
  if (!sxProps) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(sxProps).filter(([key, _]) => spacingAllowList.includes(key))
  );
};

const createMuiSpacingRules = (sxProps) => {
  return Object.entries(filterValidProps(sxProps)).reduce(
    (prev, [key, value]) =>
      prev + `${toKebabCase(key)}: ${theme.spacing(value)}px !important;\n`,
    ''
  );
};

export default createMuiSpacingRules;
